import { getAddress } from "@ethersproject/address";
import { useMediaQuery } from "@mui/material";

export function isAddress(value: any): string | false {
  try {
    return getAddress(value);
  } catch {
    return false;
  }
}

export function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

export function fillNa(arr: any) {
  const prevValues: any = {};
  let keys: any;
  if (arr.length > 0) {
    keys = Object.keys(arr[0]);
    delete keys.timestamp;
    delete keys.id;
  }

  for (const el of arr) {
    for (const key of keys) {
      if (!el[key]) {
        if (prevValues[key]) {
          el[key] = prevValues[key];
        }
      } else {
        prevValues[key] = el[key];
      }
    }
  }
  return arr;
}

export function useIsMobile() {
  return useMediaQuery("(max-width: 1080px)");
}

export const getObjectKey = (obj: any, value: any) => {
  return Object.keys(obj).find((key) => obj[key] == value);
};
